/**
 * Site-wide business data and content
 * Single source of truth for all site-specific information
 */

// Business Identity
export const PRACTICE_NAME = 'Psychotherapeutische Praxis (HeilPrG)'

export const THERAPIST_NAME = 'Astrid Jung';

export const SITE_TAGLINE = 'Heilpraktikerin für Psychotherapie'

// Contact Information
export const CONTACT_INFO = {
  email: 'jung@therapie-eltville.de',
  phone: '06723-8049249',
  address: {
    street: 'Eisenbahnstraße 6',
    zipCity: '65347 Eltville am Rhein, OT Hattenheim',
    full: 'Eisenbahnstraße 6, 65347 Eltville - Hattenheim'
  },
    openingHours: {
        monday: '7:30 - 17:00 Uhr',
        tuesday: '7:30 - 17:00 Uhr',
        wednesday: '7:30 - 20:00 Uhr',
        thursday: '7:30 - 18:00 Uhr',
        friday: '7:30 - 17:00 Uhr'
    }
}

export const getMapLinks = (address = CONTACT_INFO.address.full) => {
    const encoded = encodeURIComponent(address)
    return {
        google: `https://www.google.com/maps/search/?api=1&query=${encoded}`,
        apple: `https://maps.apple.com/?q=${encoded}`,
        osm: `https://www.openstreetmap.org/search?query=${encoded}`
    }
}

export const SITE_LABELS = {
  backButtonLabel: '↑ zurück',
  backButtonToMoreInfoLabel: '← zurück'
}